export const inactiveColor = '#e4e4f0';
export const solarOnlyColorSchemeDefault: InteractiveMapStateColorScheme = {
  primaryColor: '#0085fe',
  hoverColor: '#0059be',
};

export const solarAndBatteryColorSchemeDefault: InteractiveMapStateColorScheme =
  {
    primaryColor: '#4bac81',
    hoverColor: '#038761',
  };

export const interactiveMapColorsMap: {
  [key in InteractiveMapColors]: InteractiveMapStateColorScheme;
} = {
  'Shamrock Green': { primaryColor: '#4bac81', hoverColor: '#038761' },
  'Cyan Blue': { primaryColor: '#0085fe', hoverColor: '#0059be' },
  'Dark Blue': { primaryColor: '#1F2747', hoverColor: '#101526' },
  'Light Blue': { primaryColor: '#A5C9FF', hoverColor: '#84A1CC' },
};

export enum InteractiveMapColors {
  'Shamrock Green' = 'Shamrock Green',
  'Cyan Blue' = 'Cyan Blue',
  'Dark Blue' = 'Dark Blue',
  'Light Blue' = 'Light Blue',
}

export interface InteractiveMapStateColorScheme {
  primaryColor: string;
  hoverColor: string;
}
